import Splide from '@splidejs/splide';

export const testimonialSlider = (selector = '.sp-testimonials') => {
    const sliders = document.querySelectorAll(selector);

    if (sliders.length > 0) {
        sliders.forEach(function (slider) {
            const ul = slider.querySelector('.splide__list');

            for (let i = ul.children.length; i >= 0; i--) {
                ul.appendChild(ul.children[(Math.random() * i) | 0]);
            }

            new Splide(slider, {
                type: 'loop',
                pagination: false,
                speed: 300,
            }).mount();
        });
    }
};
